// ─────────────────────────────────────────────
// Oike Diagnostic — transcript files read in the browser
// A .txt, .vtt or .docx file is turned into text here and then follows exactly
// the same flow as pasted text (preview, cleaning and saving on the server).
// The file itself is never uploaded or stored. No audio.
// ─────────────────────────────────────────────

export const TRANSCRIPT_FILE_TYPES = ['.txt', '.vtt', '.docx'];
export const TRANSCRIPT_FILE_ACCEPT = '.txt,.vtt,.docx,text/plain,text/vtt,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const TRANSCRIPT_FILE_MAX_BYTES = 15 * 1024 * 1024;

export class TranscriptFileError extends Error {
  constructor(code) { super(code); this.code = code; }
}

/** 'txt' | 'vtt' | 'docx', or null for anything else (audio included). */
export function transcriptFileKind(name) {
  const m = String(name || '').toLowerCase().match(/\.(txt|vtt|docx)$/);
  return m ? m[1] : null;
}

/** Text of a transcript file from its name and contents. */
export async function extractTranscriptText(name, arrayBuffer) {
  const kind = transcriptFileKind(name);
  if (!kind) throw new TranscriptFileError('unsupported');
  if (arrayBuffer.byteLength > TRANSCRIPT_FILE_MAX_BYTES) throw new TranscriptFileError('too_large');
  if (kind === 'docx') {
    let value;
    try {
      const mod = await import('mammoth');
      const mammoth = mod.default || mod;
      // arrayBuffer: browser build; buffer: Node build (tests)
      ({ value } = await mammoth.extractRawText({ arrayBuffer, buffer: arrayBuffer }));
    } catch {
      throw new TranscriptFileError('unreadable');
    }
    return value;
  }
  // UTF-8; the decoder drops the BOM
  return new TextDecoder('utf-8').decode(arrayBuffer);
}

/** Text of a File chosen in the browser. */
export async function readTranscriptFile(file) {
  if (!transcriptFileKind(file.name)) throw new TranscriptFileError('unsupported');
  if (file.size > TRANSCRIPT_FILE_MAX_BYTES) throw new TranscriptFileError('too_large');
  return extractTranscriptText(file.name, await file.arrayBuffer());
}
